import React, { useState } from "react";
import { Autocomplete, TextField } from "@mui/material";

const SearchSelection = ({
  label,
  value,
  options = [],
  onChange,
  loading = false,
  disabled = false,
  required = false,
}) => {
  return (
    <div className="form_field_wrapper">
      <label>
        {label}
        {required && <span style={{ color: "red" }}>*</span>}
      </label>
      <Autocomplete
        fullWidth
        size="small"
        value={value}
        options={options}
        getOptionLabel={(option) => {
          if (typeof option === "string") return option;
          return option?.clone_id || "";
        }}
        isOptionEqualToValue={(option, value) => {
          if (typeof option === "string" && typeof value === "string") {
            return option === value;
          }
          return option?.clone_id === value?.clone_id;
        }}
        onChange={(event, newValue) => onChange(newValue)}
        loading={loading}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={`Search ${label}`}
            variant="outlined"
          />
        )}
      />
    </div>
  );
};

export default SearchSelection;
